<div class="popup modal-header w-100 d-inline-block  pb-0 mb-0">
   
    <div >
      <div class="d-flex justify-content-between align-items-center header">
        <p >Extra Services</p>
        <div class="text-right" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      </div>
      
      <p class="title text-left"> What service would like us to help you with? </p>

      <div class="d-flex justify-content-between align-items-center date my-3 " (click)="requestFlight()" >
          <p>Flights</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="requestRental()" >
          <p class="pb-0">Long Term Rentals or Relocation</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="requestTravel()" >
          <p class="pb-0">Airport Transfer</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="requestAirport()" >
          <p class="pb-0">Airport Lounges</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="requestCar()" >
          <p class="pb-0">Car Rental</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="requestVisa()" >
          <p class="pb-0">Immigration & Visas</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="requestRemoval()" >
          <p class="pb-0">Removal Service</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      
    </div>
  </div>
  